import { render, staticRenderFns } from "./CreateClaimAddParts.vue?vue&type=template&id=3e9ae136"
import script from "./CreateClaimAddParts.vue?vue&type=script&lang=js"
export * from "./CreateClaimAddParts.vue?vue&type=script&lang=js"
import style0 from "./CreateClaimAddParts.vue?vue&type=style&index=0&id=3e9ae136&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports